import debounce from 'transmute/debounce';
// @ts-expect-error Untyped import
import { EVENTS } from '../lib/usageTracker';
import { getPageNameFromPath } from './urls';
// @ts-expect-error Untyped import
import { trackEvent } from '../lib/usageTracker';
import * as storage from 'reporting-data/lib/storage';
import { SEARCH_REFERRER_STORAGE_KEY } from '../constants/globalSearch';
const RECENT_SEARCHES_STORAGE_KEY = 'reportsList:recentlySearched';
const RECENT_SEARCHES_LIMIT = 3;
export function getRecentSearches() {
  return storage.get(RECENT_SEARCHES_STORAGE_KEY) || [];
}
export function getUpdatedSearchList(newSearch) {
  const trimmedSearch = newSearch.trim();
  const searches = getRecentSearches().filter(search => search !== trimmedSearch);
  if (trimmedSearch !== '') {
    searches.unshift(trimmedSearch);
  }
  return searches.slice(0, RECENT_SEARCHES_LIMIT);
}
export function trackSearch(value) {
  const referrer = window.sessionStorage.getItem(SEARCH_REFERRER_STORAGE_KEY);
  const referrerName = referrer && getPageNameFromPath(referrer);
  trackEvent(EVENTS.searchAllReports, {
    filterValue: value,
    source: referrerName,
    subscreen: 'global-search'
  });
}
export function recordRecentSearch(value) {
  const updatedSearchList = getUpdatedSearchList(value);
  storage.set(RECENT_SEARCHES_STORAGE_KEY, updatedSearchList);
}
export function recordAndTrackSearch(value) {
  recordRecentSearch(value);
  trackSearch(value);
}
export const debounceRecordAndTrackSearch = debounce(2000, (value, recordSearch) => {
  recordSearch(value);
});
export const debounceSearch = debounce(500, (value, updateSearchFilter) => {
  updateSearchFilter(value);
});
export function dedupeSearchResults(aiSearchResults, searchResults) {
  if (!aiSearchResults) {
    return searchResults;
  }
  const aiTemplateKeys = aiSearchResults.map(result => result.templateKey);
  return searchResults.filter(result => !aiTemplateKeys.includes(result.get('templateKey')));
}